import { IsNotEmpty, IsString, MaxLength, IsBoolean, IsInt, IsOptional, IsArray, MinLength } from 'class-validator';

export class CollectiveAgreementRateEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsNotEmpty()
    @IsBoolean()
    monday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    tuesday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    wednesday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    thursday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    friday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    saturday: boolean;

    @IsNotEmpty()
    @IsBoolean()
    sunday: boolean;

    @IsNotEmpty()
    @IsString()
    @MinLength(5)
    @MaxLength(5)
    from: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(5)
    @MaxLength(5)
    to: string;

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsNotEmpty()
    @IsInt()
    addition: number;

    @IsNotEmpty()
    @IsInt()
    additionType: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    collectiveAgreements: Array<string>;

}
